$(document).on(
  "pubgm_mainsite_wiki_list rendered",
  {},
  function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
    // $("#blockNews.news").each(function () {
    //   var postsTag = "#" + $(this).attr("id");

    //   $().vPortal({
    //     container: postsTag,
    //     el: {
    //       tabContainer: "#blockNews.news_tab > ul",
    //       resultContainer: ".news_list",
    //     },
    //     paginationOptions: {},
    //   });
    // });
  }
);
